import { URI } from '@/config/config';

export default async ({ rootState }) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };

  const userLoginInfoResult = await fetch(
    `${URI}control-panel/load-configurations`,
    opts,
  );
  const jsonResult = await userLoginInfoResult.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }
  return jsonResult.configurations;
};
